module.exports = __webpack_public_path__ + "static/media/e-sports4.e3254c41.jpg";